import { useContext, useEffect, useState } from "react";
import contextBabylon from "../../../../../context/index.js";
import { calendarFormatData } from "../helpers/index.js";
const useFormatInputDate = (date, enableTime = false, inputRef)=>{
    const { Language  } = useContext(contextBabylon);
    const [inputValue, setInputValue] = useState(date ? ' ' : '');
    useEffect(()=>{
        if (date) {
            calendarFormatData(date, enableTime ? 'ccc, dd LLL HH:mm' : 'ccc, dd LLL', Language).then((formatedDate)=>{
                if (inputRef?.current) {
                    setInputValue(formatedDate);
                    inputRef.current.value = formatedDate;
                }
            }).catch(console.error);
        }
    });
    return inputValue;
};
export default useFormatInputDate;

//# sourceMappingURL=useFormatDate.js.map